/* eslint-disable no-prototype-builtins */

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import AddIcon from '@mui/icons-material/Add'
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined'

import { minimumOnboardingPrompts, positionChangeWidthSm, promptsArray } from '../../../helpers/variableDefaults'
import { descriptionTextField } from '../../../helpers/textfields'
import { selectElementWithIndex } from '../../../helpers/selects'
import { titleAndAdvisoryJSX, addBioItemIconButtonJSX, deleteBioItemIconButtonJSX, aboutMeElementsJSX, promptsElementsJSX, hobbiesElementsJSX } from '../../../helpers/commonJSX'

export const bioOnboardingJSX = (
  bioObject, setBioObject,
  loadingBio, setLoadingBio,
  bioErrors, setBioErrors,
  width
) => {

  const handleBioItemChange = (e, setErrors, setForm, form, index) => {
    e.preventDefault()
    const { name, value } = e.target
    // console.log('name ->', name)
    // console.log('value ->', value)
    // console.log('index ->', index)

    if (name === 'aboutMe' && value !== ' ') {
      let newAboutMe = [ ...form.aboutMe ]
      newAboutMe[index] = value
      if (
        value === ''
        && newAboutMe.filter(aboutMeItem => aboutMeItem.trim().length === 0).length > 1
      ) {
        newAboutMe = newAboutMe.length === newAboutMe.filter(aboutMeItem => aboutMeItem.trim().length === 0).length ? [''] : [ ...newAboutMe.filter(aboutMeItem => aboutMeItem.trim().length > 0), '']
      }
      setForm({ 
        ...form, 
        aboutMe: newAboutMe,
      })
    } else if (name === 'promptResponse' && value !== ' ') {
      const newPrompts = [ ...form.prompts ]
      newPrompts[index].response = value

      setForm({ 
        ...form, 
        prompts: newPrompts,
      })
    } else if (name === 'prompt' && value !== ' ') {
      const newPrompts = [ ...form.prompts ]
      newPrompts[index].prompt = value
      setForm({ 
        ...form, 
        prompts: newPrompts,
      })
    } else if (name === 'hobbies' && value !== ' ') {
      // console.log('hobbies should set')
      const newHobbies = [ ...form.hobbies ]
      newHobbies[index] = value
      setForm({ 
        ...form, 
        hobbies: newHobbies,
      })
    }
  }

  // Add Bio Item JSX
  const addBioItemJSX = (itemType, disabled) => {

    const handleAddItem = () => {
      if (itemType === 'aboutMe') {
        const newAboutMe = [ ...bioObject.aboutMe, '' ]
        setBioObject({ 
          ...bioObject, 
          aboutMe: newAboutMe,
        })
      } else if (itemType === 'prompts') {
        const newPrompts = [ 
          ...bioObject.prompts, 
          {
            prompt: '',
            response: '',
          } 
        ]
        setBioObject({ 
          ...bioObject, 
          prompts: newPrompts,
        })
      } else if (itemType === 'hobbies') {
        const newHobbies = [ ...bioObject.hobbies, '' ]
        setBioObject({ 
          ...bioObject, 
          hobbies: newHobbies,
        })
      }
    }

    return (
      <>
        {addBioItemIconButtonJSX(handleAddItem, disabled)}
      </>
    )
  }

  // Delete Bio Item JSX
  const deleteBioItemJSX = (itemType, index, disabled = false) => {
    const handleDeleteBioItem = (e) => {
      e.preventDefault()
      
      if (!disabled) {
        if (itemType === 'aboutMe') {
          const newAboutMe = [ ...bioObject.aboutMe.filter((x, i) => i !== index) ]
          setBioObject({ 
            ...bioObject, 
            aboutMe: newAboutMe,
          })
        } else if (itemType === 'prompts') {
          const newPrompts = [ ...bioObject.prompts.filter((x, i) => i !== index) ]
          setBioObject({ 
            ...bioObject, 
            prompts: newPrompts,
          })
        } else if (itemType === 'hobbies') {
          const newHobbies = [ ...bioObject.hobbies.filter((x, i) => i !== index) ]
          setBioObject({ 
            ...bioObject, 
            hobbies: newHobbies,
          })
        }
      }

    }
    return (
      <>
        {deleteBioItemIconButtonJSX(disabled, handleDeleteBioItem, width)}
      </>
    )
  }

  // About Me JSX
  const aboutMeJSX = () => {
    return (
      <>
        {aboutMeElementsJSX(bioObject.aboutMe, deleteBioItemJSX, handleBioItemChange, setBioErrors, bioObject, setBioObject )}
      </>
    )
  }

  // Prompts JSX
  const promptsJSX = () => {

    return (
      <>
        {promptsElementsJSX(bioObject.prompts, false, handleBioItemChange, setBioErrors, bioObject, setBioObject, width)}
      </>
    )
  }

  // Hobbies JSX
  const hobbiesJSX = () => {
    return (
      <>
        {hobbiesElementsJSX('onboarding', bioObject.hobbies, deleteBioItemJSX, handleBioItemChange, setBioErrors, bioObject, setBioObject)}
      </>
    )
  }

  return (
    <Box
      sx={{
        width: '90%',
        display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
      }}
    >

      {/* About Me Section */}
      {/* Title and Advisory JSX */}
      {/* {titleAndAdvisoryJSX(
        'About Me', 
        '*Up to 3 long-form bios',
        0
      )} */}

      {/* About Me JSX */}
      {/* {aboutMeJSX()} */}

      {/* Add About Me Button */}
      {/* {addBioItemJSX(
        'aboutMe',
        bioObject.aboutMe.length > 2 || bioObject.aboutMe.filter(aboutMeItem => aboutMeItem.trim().length === 0).length > 0
      )} */}


      {/* Prompts and Responses Section */}
      {/* Title and Advisory JSX */}
      {titleAndAdvisoryJSX(
        'Prompts', 
        `*${minimumOnboardingPrompts} prompts and responses`,
        0
      )}

      {/* Prompts JSX */}
      {promptsJSX()}

      {/* Add Prompt Button */}
      {/* {addBioItemJSX(
        'prompts',
        bioObject.prompts.length > 5 || bioObject.prompts.filter(promptItem => (promptItem.prompt.trim().length === 0 || promptItem.response.trim().length === 0)).length > 0
      )} */}


      {/* Hobbies Section */}
      {/* Title and Advisory JSX */}
      {/* {titleAndAdvisoryJSX(
        'Hobbies/Interests', 
        '*Up to 15 hobbies/interests',
        4
      )} */}

      {/* Hobbies JSX */}
      {/* {hobbiesJSX()} */}

      {/* Add Hobby Button */}
      {/* {addBioItemJSX(
        'hobbies',
        bioObject.hobbies.length > 14 || bioObject.hobbies.filter(hobby => hobby.trim().length === 0).length > 0
      )} */}

    </Box>
  )
}